module.exports = __webpack_public_path__ + "media/images/front/thumb1-fde14031f38372ddc5301f3a9a54ad21.jpg";